package ui.campaign.detailv2.editor.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Plus
import provider.LocalDisplayProvider

@Composable
fun BoxScope.AddActionButton(onClick: () -> Unit) {
    val display = LocalDisplayProvider.current
    if (display.isMobileOrSmall) {
        Box(
            modifier = Modifier.align(Alignment.BottomEnd)
                .background(
                    color = MaterialTheme.colorScheme.primaryContainer,
                    shape = RoundedCornerShape(8.dp, 0.dp, 0.dp, 0.dp)
                )
                .clip(RoundedCornerShape(8.dp, 0.dp, 0.dp, 0.dp))
                .clickable { onClick() }
        ) {
            Icon(
                modifier = Modifier.padding(12.dp).size(32.dp),
                imageVector = Svg.Plus,
                contentDescription = null
            )
        }
    } else {
        ElevatedCard(
            onClick = onClick,
            modifier = Modifier.align(Alignment.BottomEnd).padding(16.dp),
            shape = RoundedCornerShape(8.dp),
            colors = CardDefaults.elevatedCardColors(
                containerColor = MaterialTheme.colorScheme.primaryContainer,
                contentColor = MaterialTheme.colorScheme.onPrimaryContainer,
            )
        ) {
            Icon(
                modifier = Modifier.padding(12.dp).size(32.dp),
                imageVector = Svg.Plus,
                contentDescription = null
            )
        }
    }
}